export enum Locale {
  EN_US = 'en-US',
  RU_RU = 'ru-RU'
}

export type LocaleType = {
  id: Locale;
  title: string;
};
